import base from '~base';
import { toggleFormElementStates } from '../thirdParty/bootstrap/toggleFormElementsStates';

const SELECTORS = {
  ALLOWED_FORMS: ['.newsletter-form', '.registration__form'],
};

base.includeOptInFormElementsVisibility = () => {
  const flag = SELECTORS.ALLOWED_FORMS.some(selector => document.querySelector(selector));

  if (flag) {
    toggleFormElementStates();
  }
};

base.stopEnterKey = () => {
  document.querySelector('.newsletter-form').addEventListener('keypress', (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  });
};

export default base;
